import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=996cb1b8"
import script from "./tooltip.ts?vue&type=script&lang=ts&external"
export * from "./tooltip.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports